import psl from 'psl';

/**
 * Extracts the main (registrable) domain from a URL or hostname.
 *
 * Uses the Public Suffix List (via `psl`) so multi-part TLDs are handled
 * correctly, e.g. "www.shop.example.co.uk" -> "example.co.uk".
 *
 * @param {string} input - A URL or hostname.
 * @returns {string|null} The registrable domain, or null if it can't be parsed.
 */
export function getMainDomain(input) {
    const hostname = normalizeDomain(input);
    if (!hostname) {
        return null;
    }

    const parsed = psl.parse(hostname);
    return parsed.error ? null : parsed.domain;
}

export function normalizeDomain(input) {
    try {
        // Add protocol if missing
        if (!input.startsWith('http')) {
            input = 'https://' + input;
        }

        const url = new URL(input);

        // Remove "www."
        return url.hostname.replace(/^www\./, '');
    } catch (err) {
        return null;
    }
}
